export default "__VITE_ASSET__BxsB3Zt2__"